// extracted by mini-css-extract-plugin
export default {"container":"page-inbox_container__4of4U"};